import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class CreateCustomCertificateForm {
  public websiteId: number = 0;
  public certificate: string = '';
  public key: string = '';
  public caBundle: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    websiteRules: [
      (v: number) => v <= 0 || 'Invalid website selected',
    ],
    certificateRules: [
      (v: string) => !!v || 'Certificate is required',
      (v: string) => v.startsWith('-----BEGIN CERTIFICATE-----') || 'Certificate is invalid',
      (v: string) => v.endsWith('-----END CERTIFICATE-----\n') || 'Certificate is invalid',
    ],
    caBundleRules: [
      (v: string) => (v.length === 0 || v.startsWith('-----BEGIN CERTIFICATE-----')) || 'CA Bundle is invalid',
      (v: string) => (v.length === 0 || v.endsWith('-----END CERTIFICATE-----\n')) || 'CA Bundle is invalid',
    ],
    keyRules: [
      (v: string) => !!v || 'key is required',
      (v: string) => v.startsWith('-----BEGIN PRIVATE KEY-----') || 'Private Key is invalid',
      (v: string) => v.endsWith('-----END PRIVATE KEY-----\n') || 'Private Key is invalid',
    ],
  };
}
